import { createContext, useContext, type PointerEvent } from 'react';

type DomId = string;

interface ModalContextValue {
    titleId?: DomId;
    onClose?: () => void;
    onHeaderPointerDown?: (e: PointerEvent) => void;
}

export const ModalContext = createContext<ModalContextValue | undefined>(undefined);
export const useModalContext = () => useContext(ModalContext);
